import { createStore } from "redux";
import { Reducers } from "../reducers";

export const Store = createStore(
  Reducers,
  // eslint-disable-next-line no-underscore-dangle
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
